<!-- 新增或修改 -->
<template>
  <Dialog
    :title="title"
    :modelValue="modelValue"
    @onClosed="handleClosed"
    @onConfirm="handleAddUpdate"
  >
    <template #content>
      <el-form ref="formRef" :model="formData" label-width="82px" :rules="formDataRules">
        <el-form-item label="仓库名称" prop="warehouseName">
          <el-input
            v-model="formData.warehouseName"
            placeholder="请输入仓库名称"
          />
        </el-form-item>
        <el-form-item label="仓库编码" prop="warehouseCode">
          <el-input
            v-model="formData.warehouseCode"
            placeholder="请输入仓库编码"
          />
        </el-form-item>
        <el-form-item label="仓库地址">
          <el-input
            v-model="formData.warehouseAddress"
            placeholder="请输入仓库地址"
          />
        </el-form-item>
      </el-form>
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "@/components/Element/Dialog";
import { ref, onMounted, watch } from "vue";
import useCacheStore from "@/store/modules/cache";
import { isNull } from "@/utils/fangerUtils";
import { addWarehouse, updateWarehouse } from "@/api/warehouse/warehouse";

const cacheStore = useCacheStore(); // 缓存store
const { getDictListByParentCode } = cacheStore;

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "新增",
  },
  data: {
    type: Object,
    default: () => ({}),
  },
});
const formDataRules = ref({
  warehouseName: [
    {
      required: true,  // 必填
      trigger: 'blur',
      message: '仓库名称为必填项'
    }
  ],
  warehouseCode: [
    {
      required: true,
      trigger: 'blur',
      message: '仓库编码为必填项' // 验证规则
    }
  ]
})
const emits = defineEmits(["update:modelValue", "success"]);

const handleClosed = () => {
  emits("update:modelValue", false);
};

const formData = ref({});
const formRef = ref(null);

const handleAddUpdate = () => {
  formRef.value.validate((valid) => {
    if (!valid) return;
    // 新增
    if (isNull(formData.value?.warehouseId)) {
      addWarehouse(formData.value)
        .then((res) => {
          handleClosed();
          emits("success", formData.value);
        })
        .catch((res) => {});
    } else {
      // 修改
      updateWarehouse(formData.value)
        .then((res) => {
          handleClosed();
          emits("success", formData.value);
        })
        .catch((res) => {});
    }
  });
};

onMounted(() => {
  watch(
    () => props.data,
    (newVal) => {
      if (isNull(newVal)) {
        formData.value = {};
      } else {
        formData.value = { ...newVal };
      }
    }
  );
});
</script>

<style lang="scss" scoped></style>
